import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ReauthModalCommands } from './reauth-modal.commands';
import { ReauthModalQueries } from './reauth-modal.queries';

@Component({
  selector: 'app-reauth-modal',
  templateUrl: './reauth-modal.component.html',
  styleUrls: ['./reauth-modal.component.scss'],
})
export class ReauthModalComponent implements AfterViewInit, OnDestroy {
  verificationCode = '';
  readonly recaptchaContainer = 'recaptchaContainer';

  constructor(
    private readonly commands: ReauthModalCommands,
    readonly queries: ReauthModalQueries,
  ) {}

  ngAfterViewInit() {
    this.commands.sendSMS(this.recaptchaContainer);
  }

  onSubmit() {
    this.commands.confirmVerificationCode(this.verificationCode);
  }

  onCancel() {
    this.commands.cancel();
  }

  resendSMS() {
    this.commands.sendSMS(this.recaptchaContainer);
  }

  ngOnDestroy() {
    this.commands.resetState();
  }
}
